<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6JUC5']['10'] }}
          </h3>
        </div>

        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['110'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codinput" name="coddesc_codinput">{{ detail.codinput }} - {{ detail.desc_codinput }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.codempid }} - {{ detail.desc_codempid }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="dtereq" name="dtereq">{{ setDateOutput(detail.dtereq) }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['60'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codtparg" name="coddesc_codtparg">{{ detail.codtparg }} - {{ detail.desc_codtparg }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['35'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="namcourse" name="namcourse">{{ detail.namcourse }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codcours" name="coddesc_codcours">{{ detail.codcours }} - {{ detail.desc_codcours }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="numclseq" name="numclseq">{{ detail.numclseq }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['120'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="dtetr_btw" name="dtetr_btw">{{ setDateOutput(detail.dtetrst) }} - {{ setDateOutput(detail.dtetren) }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['75'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codinsts" name="coddesc_codinsts">{{ detail.codinsts }} - {{ detail.desc_codinsts }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['80'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="coddesc_codhotel" name="coddesc_codhotel">{{ detail.codhotel }} - {{ detail.desc_codhotel }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['90'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="amtbudg" name="amtbudg">{{ detail.amtbudg }}</div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['140'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70" id="filename" name="filename">
                      <a :href="baseURL + detail.path_filename" target="_blank" @click.stop v-show="typeof detail.path_filename !== 'undefined' && detail.path_filename !== ' ' && detail.filename !== ' '">
                        <i class="fa fa-paperclip"></i> {{ detail.filename }}
                      </a>
                    </div>
                </div>
              </div>
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES6JUC5']['100'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70 txtarea-width response-full-width" id="remark" name="remark">{{ detail.remark }}</div>
                </div>
              </div>

              <div align="right">
                <button class="btn bg-blue" data-toggle="modal" data-target="#hres6ju-popup"><i class="fa fa-list-alt"></i> {{ labels['HRES6JUC4']['10'] }}</button>
              </div>

              <popup  :labels="labels"
                      :nowLang="nowLang"
                      :labelsButton="labelsButton"
                      :arrCodtparg="arrCodtparg"
                      :popupTab1="popupTab1"
                      :tab1PopupTable1="tab1PopupTable1"
                      :tab1PopupTable2="tab1PopupTable2"
                      :maxRowspanPopupTable1="maxRowspanPopupTable1"
                      :receivedHres6juDetailPopup="receivedHres6juDetailPopup"
                      :codempid="detail.codempid"
                      :descCodempid="detail.desc_codempid" />

            </div>
          </div>
        </div>
      </div>
    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import env from 'src/../env.js'
import popup from 'components/hres6ju/popup'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6ju-detail',
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  props: [
    'labels',
    'detail',
    'popupTab1',
    'toggle',
    'data',
    'nowLang',
    'labelsButton',
    'maxRowspanPopupTable1',
    'tab1PopupTable1',
    'tab1PopupTable2',
    'arrCodtparg',
    'receivedHres6juDetailPopup'
  ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    popup
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?4ae21b28